import Hotjar from '@hotjar/browser'

export const initHotjar = () => {
  // ensure we're on production
  if (window.location.href.startsWith('https://www.renderforest.com/')) {
    const siteId = 3915117
    const hotjarVersion = 6
    const country = window.CURRENT_COUNTRY
    const disabledCountries = ['IN', 'AM']

    if (!disabledCountries.includes(country)) {
      Hotjar.init(siteId, hotjarVersion)
    }
  }
}
